










































































/* ----------------------------------------
    Imports
---------------------------------------- */

import { Component, Vue } from 'vue-property-decorator';
import { UserService } from '@store/service/UserService';
import PageMain from '@part/layout/PageMain.vue';
import RegisterForm from '@part/auth/RegisterForm.vue';
import ResetForm from '@part/auth/ResetForm.vue';

/* ----------------------------------------
    Component
---------------------------------------- */

@Component({
    data() {
        return {
            userData: null,
            post: {
                password: '',
                terms: false,
            }
        }
    },

    components: {
        RegisterForm,
        PageMain,
        ResetForm,
    },

    computed: {
        genderText() {
            if (!this.userData) return '';
            if (this.userData.gender === 0) return 'Mevr.';
            if (this.userData.gender === 1) return 'Dhr.';
            if (this.userData.gender === 2) return 'N.v.t.';
        }
    },

    created() {
        const userService = new UserService(this.$store);
        const token = this.$route.query.token;
        userService.getInvite(token).then(response => {
            this.userData = response.data;
        })
    }
})

/* ----------------------------------------
    Export
---------------------------------------- */

export default class InvitedView extends Vue {}

